import TraderPmgClosedSalesList from '../../../trader/PMG/SalesList/TraderPmgClosedSalesList'

export const CustomerPmgClosedSalesList = TraderPmgClosedSalesList

export default CustomerPmgClosedSalesList
